const PAT_API_URL =
  window.location.hostname === "pomelclothing.com" ||
  window.location.hostname === "www.pomelclothing.com"
    ? "https://pat-standalone.onrender.com/chat"
    : "/chat";

function createSessionId() {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID().replaceAll("-", "");
  }

  return `pat_${Date.now()}_${Math.random().toString(36).slice(2)}`;
}

let sessionId = localStorage.getItem("patSessionId");

if (!sessionId) {
  sessionId = createSessionId();
  localStorage.setItem("patSessionId", sessionId);
}

const launcher = document.querySelector("#pat-launcher");
const widget = document.querySelector("#pat-widget");
const closeButton = document.querySelector("#pat-close");
const newChatButton = document.querySelector("#pat-new-chat");
const form = document.querySelector("#pat-form");
const input = document.querySelector("#pat-input");
const messages = document.querySelector("#pat-messages");
const sendButton = form.querySelector('button[type="submit"]');

function openWidget() {
  document.body.classList.add("pat-chat-open");
  document.documentElement.classList.add("pat-chat-open");

  if (!widget.open) {
    widget.showModal();
  }

  launcher.setAttribute("aria-expanded", "true");

 
}

function closeWidget() {
  if (widget.open) {
    widget.close();
  }

  document.body.classList.remove("pat-chat-open");
  document.documentElement.classList.remove("pat-chat-open");

  launcher.setAttribute("aria-expanded", "false");
}

function startNewChat() {
  sessionId = createSessionId();
  localStorage.setItem("patSessionId", sessionId);

  messages.replaceChildren();

  addMessage(
    "Hey 👋 I’m PAT. What are we looking for today?",
    "assistant"
  );

  input.value = "";
  input.focus();
}

function renderSafePatText(container, text) {
  const value = String(text || "");
  const parts = value.split(/(\*\*[^*]+\*\*)/g);

  for (const part of parts) {
    if (!part) continue;

    if (
      part.startsWith("**") &&
      part.endsWith("**") &&
      part.length > 4
    ) {
      const strong = document.createElement("strong");
      strong.textContent = part.slice(2, -2);
      container.appendChild(strong);
      continue;
    }

    const lines = part.split("\n");

    lines.forEach((line, index) => {
      if (index > 0) {
        container.appendChild(document.createElement("br"));
      }

      container.appendChild(document.createTextNode(line));
    });
  }
}

function addMessage(text, sender) {
  const message = document.createElement("div");

  message.className =
    sender === "user"
      ? "pat-message pat-message-user"
      : "pat-message pat-message-assistant";

  renderSafePatText(message, text);
  messages.appendChild(message);
  messages.scrollTop = messages.scrollHeight;

  return message;
}

function formatPrice(price) {
  if (!price || typeof price.amount !== "number") {
    return "Price unavailable";
  }

  const currency = price.currency || "USD";

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  }).format(price.amount / 100);
}

function createProductCard(product) {
  const card = document.createElement("article");
  card.className = "pat-product-card";

  if (product.image) {
    const image = document.createElement("img");
    image.className = "pat-product-image";
    image.src = product.image;
    image.alt = product.title || "Pomel product";
    image.loading = "lazy";
    card.appendChild(image);
  }

  const content = document.createElement("div");
  content.className = "pat-product-content";

  const title = document.createElement("h2");
  title.className = "pat-product-title";
  title.textContent = product.title || "Pomel product";

  const price = document.createElement("p");
  price.className = "pat-product-price";
  price.textContent = formatPrice(product.price);

  const availability = document.createElement("p");
  availability.className = "pat-product-availability";

  if (product.available === true) {
    availability.textContent = "Available";
  } else if (product.available === false) {
    availability.textContent = "Unavailable";
  } else {
    availability.textContent = "Availability not confirmed";
  }

  content.append(title, price, availability);
const usefulReasons = Array.isArray(
  product.recommendationReasons
)
  ? product.recommendationReasons
      .filter((reason) => {
        const normalized = String(reason).toLowerCase();

        return (
          normalized !== "available" &&
          normalized !== "unavailable" &&
          !normalized.startsWith("above $")
        );
      })
      .slice(0, 2)
  : [];

if (usefulReasons.length > 0) {
  const why = document.createElement("p");
  why.className = "pat-product-why";

  const cleanedReasons = usefulReasons.map((reason) =>
    String(reason)
      .replace(/^Matches product type:\s*/i, "")
      .replace(/^Matches style:\s*/i, "")
      .replace(/^Matches\s+/i, "")
  );

  why.textContent =
    `✨ Why this pick: ${cleanedReasons.join(" · ")}`;

  content.appendChild(why);
}

  if (Array.isArray(product.sizes) && product.sizes.length > 0) {
    const sizes = document.createElement("p");
    sizes.className = "pat-product-sizes";
    sizes.textContent = `Sizes: ${product.sizes.join(", ")}`;
    content.appendChild(sizes);
  }

  if (product.url) {
    const link = document.createElement("a");
    link.className = "pat-product-link";
    link.href = product.url;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.textContent = "View product";
    content.appendChild(link);
  }

  card.appendChild(content);

  return card;
}

function addProductCards(products) {
  if (!Array.isArray(products) || products.length === 0) {
    return;
  }

  const container = document.createElement("div");
  container.className = "pat-products";

  products.slice(0, 3).forEach((product) => {
    container.appendChild(createProductCard(product));
  });

  messages.appendChild(container);
  messages.scrollTop = messages.scrollHeight;
}

function addQuickReplies(quickReplies) {
  if (!Array.isArray(quickReplies) || quickReplies.length === 0) {
    return;
  }

  const container = document.createElement("div");
  container.className = "pat-quick-replies";

  quickReplies.forEach((reply) => {
    if (!reply?.label || !reply?.message) {
      return;
    }

    const button = document.createElement("button");

    button.type = "button";
    button.className = "pat-quick-reply";
    button.textContent = reply.label;
    button.dataset.patMessage = reply.message;
    button.dataset.patDisplay = reply.label;

    container.appendChild(button);
  });

  if (!container.children.length) {
    return;
  }

  messages.appendChild(container);
  messages.scrollTop = messages.scrollHeight;
}

function setLoading(isLoading) {
  input.disabled = isLoading;
  sendButton.disabled = isLoading;
  sendButton.textContent = isLoading ? "..." : "Send";
}

launcher.addEventListener("click", () => {
  if (widget.open) {
    closeWidget();
  } else {
    openWidget();
  }
});

closeButton.addEventListener("click", closeWidget);
newChatButton.addEventListener("click", startNewChat);

async function sendMessage(message, displayMessage = null) {
  const cleanMessage = String(message || "").trim();
  const visibleMessage = String(
    displayMessage || cleanMessage
  ).trim();

  if (!cleanMessage) {
    return;
  }

  addMessage(visibleMessage, "user");
  input.value = "";
  setLoading(true);

  const loadingMessage = addMessage(
    "PAT is thinking...",
    "assistant"
  );

  try {
    const response = await fetch(PAT_API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        message: cleanMessage,
        sessionId,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.error || "PAT could not answer."
      );
    }

loadingMessage.replaceChildren();

renderSafePatText(
  loadingMessage,
  data.reply || "PAT returned an empty response."
);

addQuickReplies(data.quickReplies);
addProductCards(data.products);
  } catch (error) {
    console.error("PAT request failed:", error);

    loadingMessage.textContent =
      "I couldn't connect to PAT right now. Please try again.";
  } finally {
    setLoading(false);
    input.focus();
  }
}

form.addEventListener("submit", async (event) => {
  event.preventDefault();

  await sendMessage(input.value);
});

messages.addEventListener("click", async (event) => {
  const button = event.target.closest(
    "[data-pat-message]"
  );

  if (!button) {
    return;
  }

  const message = button.dataset.patMessage;
  const displayMessage =
    button.dataset.patDisplay || button.textContent.trim();

  document
    .querySelector(".pat-quick-actions")
    ?.remove();

  // Find my size should respond instantly.
  if (message === "Help me find my size") {
    addMessage(displayMessage, "user");

    addMessage(
      "Sure 📏 Which piece are you looking at? Send me the product name.",
      "assistant"
    );

    return;
  }
  if (message === "I have a question about a product") {
  addMessage(displayMessage, "user");

  addMessage(
    "Sure 💬 Which item would you like to know more about? Send me the product name.",
    "assistant"
  );

  return;
}

  await sendMessage(message, displayMessage);
});



